<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="elevation-5 mb-3">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.params.role_id">{{ form.name }}</v-toolbar-title>
      <v-toolbar-title v-else>New role</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="my-0" color="success" @click="save">save</v-btn>
    </v-toolbar>
    <progress-bar></progress-bar>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Main info</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <v-text-field v-model="form.name" :error-messages="errorMessages('name')"
                          label="Title"></v-text-field>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Settings</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <sl-extended-select
                label="Features"
                v-model="form.features"
                :data="features"
                :withOptions="false"
            />

            <sl-extended-select
                label="Users"
                v-model="form.instance_users"
                :data="instance_users"
                :withOptions="false"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'
  import users from '@/components/sl-extended-select'

  export default {
    name: 'FeaturesFormPage',
    mixins: [mixins.errors, mixins.form, mixins.preloader],
    data() {
      return {
        api: this.$api.roles,
        features: [],
        instance_users: [],
        form: {
          name: '',
          instance_id: 0,
          instances: [],
        },
      }
    },
    components: {
      'sl-extended-select': users,
    },
    watch: {
      'form.instance_id'(value) {
        this.$api.instances.get(value).then(({data}) => {
          this.features = data.features
          this.instance_users = data.instance_users
        })
      }
    },
    mounted() {
      if (this.$route.params.role_id > 0) {
        this.load(this.$route.params.role_id)
      } else {
        this.form.instance_id = this.$route.query.instance_id
      }

      this.$api.instances.list({unlimit: 1}).then(({data}) => {
        this.instances = data
      })
    },
  }
</script>
